import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentforoutstationpune() {



  const cardData = {
"keyword": "Urbania On Rent for Outstation Pune",

"headingDescription":
  "Shivai Travels offers premium Urbania on rent for outstation travel from Pune, designed for comfortable long-distance journeys with family, corporate teams, wedding groups, pilgrimage tours, and leisure trips across Maharashtra and India. Our Force Urbania rental service provides a luxury travel experience with spacious pushback seats, powerful air conditioning, smooth suspension, charging points, music system, and ample luggage capacity, ensuring maximum comfort on highways and ghat routes. Whether you are planning a weekend getaway or a multi-day outstation tour, Shivai Travels ensures safe and reliable travel with experienced drivers, well-maintained vehicles, and 24/7 customer support. Ideal for 15–17 passengers, our Urbania outstation service includes flexible options like one-way trips, round trips, multi-city tours, customized travel itineraries, and doorstep pickup and drop, making it a perfect choice for group travel from Pune.",

"topPlaces": [
  {
    "title": "Goa",
    "description":
      "Goa is the most popular outstation destination from Pune, famous for beaches, nightlife, water sports, and resorts, making it ideal for luxury Urbania group road trips."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, frequently visited by devotees traveling in comfortable Urbania rentals from Pune for darshan tours."
  },
  {
    "title": "Nashik & Trimbakeshwar",
    "description":
      "Nashik and Trimbakeshwar are important spiritual destinations known for Jyotirlinga temple, vineyards, and religious tourism, perfect for group outstation travel."
  },
  {
    "title": "Mahabaleshwar & Panchgani",
    "description":
      "Mahabaleshwar and Panchgani are scenic hill stations known for strawberries, viewpoints, lakes, and cool climate, ideal for relaxing outstation group trips."
  },
  {
    "title": "Aurangabad (Ajanta & Ellora Caves)",
    "description":
      "Aurangabad is famous for UNESCO World Heritage Sites Ajanta and Ellora Caves, making it a top cultural and heritage outstation destination from Pune."
  },
  {
    "title": "Mumbai",
    "description":
      "Mumbai is a major metro city near Pune known for tourism, business, shopping, and Marine Drive, often chosen for corporate and leisure outstation travel."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a coastal getaway near Mumbai known for beaches, forts, and resorts, making it ideal for short outstation weekend trips from Pune."
  },
  {
    "title": "Konkan Belt (Ratnagiri & Ganpatipule)",
    "description":
      "The Konkan region including Ratnagiri and Ganpatipule offers scenic beaches, coastal roads, temples, and seafood experiences for long-distance group travel."
  },
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are quick outstation destinations from Pune known for hills, waterfalls, forts, and scenic monsoon drives for group tours."
  },
  {
    "title": "Indore",
    "description":
      "Indore is a popular inter-state outstation destination known for food, culture, and business travel, suitable for long-distance Urbania group trips from Pune."
  }
],



services: [
  {
    name: "Outstation Urbania Pune",
    description: "Outstation Urbania Pune service provides premium and spacious transportation for family trips, corporate tours, sightseeing journeys, pilgrimage travel, and long-distance outstation travel. Luxury Force Urbania vehicles with experienced drivers ensure smooth and safe travel for interstate and highway routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, premium interiors, and luggage space suitable for comfortable group travel. Flexible booking options allow convenient outstation Urbania reservations in Pune."
  },
  {
    name: "Pune Outstation Urbania Rental",
    description: "Pune outstation Urbania rental service offers dependable transportation solutions for travelers planning long-distance travel from Pune to nearby cities and tourist destinations. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient outstation Urbania rental reservations."
  },
  {
    name: "Urbania Outstation Cab Pune",
    description: "Urbania outstation cab Pune service provides affordable and comfortable luxury travel options for interstate and long-distance journeys. Travelers can enjoy smooth trips with experienced drivers familiar with highways, hill stations, beaches, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and sightseeing travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation Urbania cab reservations."
  },
  {
    name: "Force Urbania Outstation Hire Pune",
    description: "Force Urbania outstation hire Pune service provides high-end transportation for passengers seeking comfortable and stylish group travel for long-distance journeys. Vehicles offer spacious seating, premium interiors, luggage capacity, and smooth ride quality suitable for tourism, wedding events, and executive travel. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Force Urbania hire reservations."
  },
  {
    name: "Luxury Urbania Outstation Pune",
    description: "Luxury Urbania outstation Pune service offers economical and comfortable luxury transportation for groups traveling from Pune to nearby destinations and tourist places. Vehicles provide smooth highway travel with spacious seating suitable for one-day tours, outstation journeys, and group outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient luxury Urbania reservations."
  },
  {
    name: "Cheap Outstation Urbania Pune",
    description: "Cheap outstation Urbania Pune service provides comfortable transportation for families, corporate teams, and tourists traveling from Pune to outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient affordable Urbania reservations."
  },
  {
    name: "Pune to Mumbai Urbania",
    description: "Pune to Mumbai Urbania service offers spacious transportation for family tours, corporate outings, airport transfers, and sightseeing trips between Pune and Mumbai. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Pune to Mumbai Urbania reservations."
  },
  {
    name: "Pune to Goa Urbania Rental",
    description: "Pune to Goa Urbania rental service provides reliable transportation for beach vacations, family tours, group outings, and sightseeing journeys from Pune to Goa. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for long-distance and interstate journeys. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Pune to Goa Urbania reservations."
  },
  {
    name: "Urbania Round Trip Outstation Pune",
    description: "Urbania round trip outstation Pune service provides dependable transportation for long-distance group travel from Pune to tourist destinations, pilgrimage places, beaches, and hill stations. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient round trip Urbania reservations."
  },
  {
    name: "Urbania One Way Outstation Pune",
    description: "Urbania one way outstation Pune service offers spacious and comfortable transportation for one-side travel from Pune to nearby cities and tourist destinations. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one-way outstation Urbania reservations."
  },
  {
    name: "Best Outstation Urbania Pune",
    description: "Best outstation Urbania Pune service offers premium transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return options. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and corporate outings. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient best outstation Urbania reservations."
  },
  {
    name: "AC Urbania Outstation Pune",
    description: "AC Urbania outstation Pune service offers reliable group transportation for long-distance sightseeing tours, airport transfers, and interstate travel. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient AC Urbania reservations."
  },
  {
    name: "Urbania with Driver Outstation Pune",
    description: "Urbania with driver outstation Pune service provides complete luxury transportation solutions for local and interstate travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, group outings, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Urbania with driver reservations."
  },
  {
    name: "Family Outstation Urbania Pune",
    description: "Family outstation Urbania Pune service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for family trips, sightseeing tours, corporate outings, and long-distance travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient family outstation Urbania reservations."
  },
  {
    name: "Premium Urbania Travel Pune",
    description: "Premium Urbania travel Pune service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination outings, sightseeing trips, and family tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient premium Urbania travel reservations."
  }
],

tableData: [
  ["Outstation Urbania Pune", "Pune Outstation Urbania Rental"],
  ["Urbania Outstation Cab Pune", "Force Urbania Outstation Hire Pune"],
  ["Luxury Urbania Outstation Pune", "Cheap Outstation Urbania Pune"],
  ["Pune to Mumbai Urbania", "Pune to Goa Urbania Rental"],
  ["Urbania Round Trip Outstation Pune", "Urbania One Way Outstation Pune"],
  ["Best Outstation Urbania Pune", "AC Urbania Outstation Pune"],
  ["Urbania with Driver Outstation Pune", "Family Outstation Urbania Pune"],
  ["Premium Urbania Travel Pune", "Outstation Urbania Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Urbania on Rent for Outstation Pune",
        WhyChoosedescription: "Shivai Travels provides reliable Urbania rental service for outstation travel from Pune with professional drivers, luxury seating, and punctual pickup for smooth and comfortable long-distance journeys."
      },
      {
        WhyChooseheading: "Affordable Outstation Urbania Rental Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Urbania on rent for outstation travel in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Urbania Outstation Availability",
        WhyChoosedescription: "Our Urbania outstation rental service in Pune operates 24 hours a day for family tours, corporate travel, weddings, pilgrimage trips, airport transfers, and group travel requirements."
      },
      {
        WhyChooseheading: "Luxury & Comfortable AC Urbania Vehicles",
        WhyChoosedescription: "All Urbania vehicles provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide premium comfort during long-distance outstation travel."
      },
      {
        WhyChooseheading: "One Way & Round Trip Outstation Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Urbania booking, round-trip outstation travel, local sightseeing, and customized tour packages from Pune."
      },
      {
        WhyChooseheading: "Perfect Vehicle for Group Outstation Travel",
        WhyChoosedescription: "Our Urbania vehicles are ideal for family vacations, corporate teams, wedding groups, tourists, and pilgrimage travel with spacious seating, luggage capacity, and luxury interiors."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Long-Distance Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with highways, hill stations, Konkan roads, pilgrimage destinations, and interstate routes, ensuring safe driving and smooth travel for every outstation journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Urbania on rent for outstation Pune?", answer: "Urbania on rent for outstation Pune provides luxury group transportation for family tours, corporate travel, sightseeing trips, pilgrimage journeys, and long-distance travel." },
    { question: "Is Urbania outstation rental service in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Urbania outstation rental service in Pune." },
    { question: "Which Urbania seating options are available for outstation travel?", answer: "Shivai Travels offers 10 seater, 13 seater, and 17 seater Urbania vehicles for outstation travel." },
    { question: "Can I book Urbania for one-way outstation travel?", answer: "Yes, customers can book Urbania vehicles for one-way as well as round-trip outstation journeys." },
    { question: "Do you provide customized outstation tour packages?", answer: "Yes, Shivai Travels provides customized Urbania tour packages for hill stations, Konkan tours, pilgrimage trips, and interstate travel." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Urbania vehicles are fully air-conditioned and maintained for comfortable luxury travel." },
    { question: "Can I book Urbania on rent for outstation Pune online?", answer: "Yes, customers can easily book Urbania outstation rental service online or through phone booking." },
    { question: "Do you provide Urbania vehicles for family and corporate group tours?", answer: "Yes, Shivai Travels provides Urbania vehicles for family tours, corporate outings, wedding groups, and group travel." },
    { question: "Are Urbania outstation rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Urbania outstation rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked Urbania on rent for outstation Pune with Shivai Travels. Luxury vehicle, smooth journey, and excellent driver support for our group tour.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Urbania outstation rental service in Pune. Affordable pricing, clean luxury vehicle, and wonderful long-distance travel experience.",
      rating: 5
    }
  ];






  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania on Rent for Outstation from Pune",
  "image": "https://shivaitravels.com/assets/images/urbania-outstation-pune.jpg",
  "description": "Book Urbania for outstation travel from Pune with Shivai Travels. Luxury AC Urbania cab for Pune to Mumbai, Pune to Goa, family trips, and group tours. Available with driver and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹28/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/urbania-outstation-pune"
  }
};



  return (
    <div>



<Helmet>
  <title>Urbania on Rent for Outstation from Pune | Pune to Mumbai, Goa Cab | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Book Urbania for outstation travel from Pune with Shivai Travels. Luxury AC Urbania cab for Pune to Mumbai, Pune to Goa, family trips, and group tours. Available with driver and 24x7 service."
  />

  <meta
    name="keywords"
    content="outstation urbania pune, pune outstation urbania rental, urbania outstation cab pune, force urbania outstation hire pune, luxury urbania outstation pune, cheap outstation urbania pune, pune to mumbai urbania, pune to goa urbania rental, urbania round trip outstation pune, urbania one way outstation pune, best outstation urbania pune, ac urbania outstation pune, urbania with driver outstation pune, family outstation urbania pune, premium urbania travel pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniaonrentforoutstationpune;